export default __webpack_public_path__ + "static/media/warehouse.f948d502.svg";